<div class="container-fluid">
    <app-breadcrumb
        [title]="module | translate"
        [active_item]="subModule | translate"
    ></app-breadcrumb>
    <div class="card">
        <div class="card-body">
            <div *ngIf="!formsView">
                <div class="rapport-container">
                    <div>
                        <app-message-box
                            [cardBgColor]="'#3498db'"
                            [cardBorderColor]="'#FFF'"
                            [legend]="
                                '# Total ' +
                                (+currentTabsIndex === 0 ? 'reçus' : 'envoyés')
                            "
                            [count]="rapport?.total || '0'"
                            [legendColor]="'#FFF'"
                            [countColor]="'#FFF'"
                            [taux]="rapport?.pourcentage_total"
                        >
                        </app-message-box>
                    </div>
                    <div>
                        <app-message-box
                            [cardBgColor]="'#27ae60'"
                            [cardBorderColor]="'#FFF'"
                            [legend]="'# Total lus'"
                            [count]="rapport?.total_lus || '0'"
                            [legendColor]="'#FFF'"
                            [countColor]="'#FFF'"
                            [taux]="rapport?.pourcentage_total_lus"
                        ></app-message-box>
                    </div>
                    <div>
                        <app-message-box
                            [cardBgColor]="'#009fff'"
                            [cardBorderColor]="'#FFF'"
                            [legend]="'# Sujet offres commerciales'"
                            [count]="rapport?.total_offres_commerciales || '0'"
                            [legendColor]="'#FFF'"
                            [countColor]="'#FFF'"
                            [taux]="
                                rapport?.pourcentage_total_offres_commerciales
                            "
                        ></app-message-box>
                    </div>
                    <div>
                        <app-message-box
                            [cardBgColor]="'#e74c3c'"
                            [cardBorderColor]="'#FFF'"
                            [legend]="'# Sujet contrat'"
                            [count]="rapport?.total_contrats || '0'"
                            [legendColor]="'#FFF'"
                            [countColor]="'#FFF'"
                            [taux]="rapport?.pourcentage_total_contrats"
                        ></app-message-box>
                    </div>
                    <div>
                        <app-message-box
                            [cardBgColor]="'#f1c40f'"
                            [cardBorderColor]="'#FFF'"
                            [legend]="'# Sujet facture'"
                            [count]="rapport?.total_factures || '0'"
                            [legendColor]="'#000000'"
                            [countColor]="'#000000'"
                            [taux]="rapport?.pourcentage_total_factures"
                        ></app-message-box>
                    </div>
                </div>
                <div>
                    <p-tabView (onChange)="handleChangeTabviewIndex($event)">
                        <p-tabPanel header="BOITE DE RECEPTION">
                            <app-recipient-wrapper
                                *ngIf="currentTabsIndex === 0"
                                (rapport)="OnPushRapport($event)"
                                [selectedTransaction]="activation"
                                [tabsLabel]="'Messages reçus'"
                            ></app-recipient-wrapper>
                        </p-tabPanel>
                        <p-tabPanel header="BOITE D'ENVOI">
                            <app-sender-wrapper
                                *ngIf="currentTabsIndex === 1"
                                (rapport)="OnPushRapport($event)"
                                (formsView)="pushStatutView($event)"
                                (currentObject)="pushCurrentObject($event)"
                                [selectedTransaction]="suspension"
                                [tabsLabel]="'Messages envoyés'"
                            ></app-sender-wrapper>
                        </p-tabPanel>
                    </p-tabView>
                </div>
            </div>
            <app-message-form
                [currentObject]="currentObject"
                (formsView)="pushStatutView($event)"
                *ngIf="formsView"
            ></app-message-form>
        </div>
    </div>
</div>
